import React, { useEffect } from 'react';

const GarantiaGloomisMX = () => {
    useEffect(() => {
        document.title = "Garantía G. Loomis | Shimano Mexico";
    }, []);

    return (
        <section className="garantia-gloomis container" style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
            <div className="sect-header">
                <div className="sect-titulo">
                    <h1 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '24px' }}>Registro de Producto G. Loomis</h1>
                </div>
            </div>

            <div className="contenido-garantia">
                <h3 style={{ marginBottom: '20px', fontSize: '16px' }}>¡Bienvenido a la familia G. Loomis!</h3>

                <p style={{ marginBottom: '15px', lineHeight: '1.6', fontSize: '12px' }}>
                    Existimos para aumentar tu disfrute en el agua. Eso es lo que nos motiva. Para ti, construimos herramientas de pesca que amplían las oportunidades, aumentan la eficiencia y potencian la habilidad natural del pescador. Dicho esto, nuestro compromiso de ofrecer experiencias superiores al cliente se mantiene incluso cuando tus líneas están secas.
                </p>

                <p style={{ marginBottom: '25px', lineHeight: '1.6', fontSize: '12px' }}>
                    Por favor, completa el formulario a continuación para registrar tu caña dentro de los 30 días posteriores a la compra. Al hacerlo, tendrás acceso a nuestro completo programa de garantía Xpeditor y a otras opciones de garantía, en caso de que necesites asistencia en el futuro.
                </p>

                {/* TEXTO EXATO CONFORME ESPECIFICADO, COM LINK EM NEGRITO */}
                <p style={{ marginBottom: '40px', lineHeight: '1.6', fontSize: '12px' }}>
                    Para registrar tu producto, simplemente {' '}
                    <a
                        href="/gloomis-registro-producto" // Substituir pela URL real
                        style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#0054A6', fontSize: '12px' }}
                    >
                        haz clic aquí
                    </a>
                    {' '} y sigue las instrucciones a continuación.
                </p>

                {/* Seção de Ajuda de Registro - Tradução literal da página americana */}
                <div className="ayuda-registro" style={{ marginTop: '40px', borderTop: '1px solid #eee', paddingTop: '30px' }}>
                    <h4 style={{ marginBottom: '25px', fontWeight: 'bold', fontSize: '14px' }}>Ayuda para el Registro del Producto</h4>

                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', textAlign: 'center' }}>

                        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px', padding: '0 10px' }}>
                            <div style={{
                                backgroundColor: '#f8f8f8',
                                padding: '20px',
                                borderRadius: '8px',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#333', fontSize: '13px' }}>Número de Serie</h5>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                    Localiza el número de serie en tu caña. El número de serie constará de 2 letras, seguidas de 5 dígitos.
                                </p>
                                <img
                                    src="/img/gl.SerialNumber.png"
                                    alt="Número de Serie"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>


                        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px', padding: '0 10px' }}>
                            <div style={{
                                backgroundColor: '#f8f8f8',
                                padding: '20px',
                                borderRadius: '8px',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#333', fontSize: '13px' }}>Número de Modelo</h5>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                    Ubicado en la etiqueta.
                                </p>
                                <img
                                    src="/img/model_number.png"
                                    alt="Número de Modelo"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>


                        <div style={{ flex: '1', minWidth: '200px', marginBottom: '20px', padding: '0 10px' }}>
                            <div style={{
                                backgroundColor: '#f8f8f8',
                                padding: '20px',
                                borderRadius: '8px',
                                minHeight: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <h5 style={{ marginBottom: '10px', color: '#333', fontSize: '13px' }}>Fecha de Nacimiento</h5>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                    Impresa en la caña.
                                </p>
                                <img
                                    src="/img/BORN_ON_DATE.png"
                                    alt="Fecha de Nacimiento"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </div>
                        </div>
                    </div>


                    <p style={{
                        marginTop: '30px',
                        fontSize: '12px',
                        fontStyle: 'italic',
                        color: '#666',
                        backgroundColor: '#f9f9f9',
                        padding: '15px',
                        borderRadius: '5px'
                    }}>
                        
                    </p>
                </div>
            </div>
        </section>
    );
};

export default GarantiaGloomisMX;